import * as Yup from "yup";
import { getPatchOperations } from "../../../../util/form";
import FmuProeveDeltagerInfo from "./FmuProeveDeltagerInfo";

export const kursusDeltagereFormConfig = (
  kursusType: number,
  kursusId: string,
  kursusPersonId?: string,
): FormConfig<KursusPersonDTO> => {
  const url = `kursus/${kursusId}/deltagere/`;
  return {
    title: "Deltager",
    lockedValues: [
      {
        id: "kursusId",
        value: kursusId,
      },
      {
        id: "kursusPersonId",
        value: kursusPersonId,
      },
    ],
    form: [
      {
        component: "person",
        id: "personId",
        label: "Deltager",
        initialValue: "",
        placeholder: "Søg og vælg deltager ...",
        locked: true,
        isRequired: true,
      },
      {
        component: "kode-select",
        id: "overnatning",
        label: "Overnatning",
        kodeListeType: "OvernatningstypeKode",
        initialValue: "MellemKursusdagene",
        placeholder: "Vælg overnatningstype",
        isRequired: true,
        conditionalHidden: () => kursusType === 5,
      },
      {
        component: "custom",
        id: "",
        customComponent({ formik }) {
          return <FmuProeveDeltagerInfo personId={formik.values.personId} />;
        },
        conditionalHidden: () => kursusType !== 5,
      },
    ],
    validationSchema: Yup.object({
      personId: Yup.string().required("Deltager skal være valgt"),
      overnatning: Yup.string().required("Overnatning skal være valgt"),
    }),
    get: url + kursusPersonId,
    post: (values) => {
      return {
        query: url,
        body: values,
      };
    },
    patch: (values) => {
      const { overnatning } = values;
      return {
        body: JSON.stringify(
          getPatchOperations({
            overnatning,
          }),
        ),
        query: url + kursusPersonId,
      };
    },
  };
};
